import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'formatTimeZone' })
export class FormatTimeZonePipe implements PipeTransform {
  private static readonly FORMATTING_DATE = DateTime.utc();

  transform(value: string, format: string, date?: DateTime | Date): string {
    const formattingDate = date == null
      ? FormatTimeZonePipe.FORMATTING_DATE
      : date instanceof Date
        ? DateTime.fromJSDate(date)
        : date;

    return formattingDate.setZone(value).toFormat(format);
  }
}
